function coerceBoolean(value, fallback = false) {
    if (value === undefined || value === null) return fallback;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (normalized === 'true') return true;
        if (normalized === 'false') return false;
    }
    return Boolean(value);
}

function getPageContactOverride(pageData = {}) {
    const value = pageData?.ContactOverride;
    const contactOverride =
        value && typeof value === 'object' && !Array.isArray(value)
            ? value
            : {};

    return {
        enabled: coerceBoolean(contactOverride.Enabled),
        phone: String(contactOverride.Phone || '').trim(),
    };
}

function getEffectivePagePhone(pageData = {}, fallback = '') {
    const contactOverride = getPageContactOverride(pageData);
    if (contactOverride.enabled && contactOverride.phone) {
        return contactOverride.phone;
    }
    return String(fallback || '').trim();
}

function applyPageContactOverride(componentName, props = {}, pageData = {}) {
    const contactOverride = getPageContactOverride(pageData);
    if (!contactOverride.enabled || !contactOverride.phone) return props;

    if (componentName === 'Nav') {
        return { ...props, Phone: contactOverride.phone };
    }
    if (componentName === 'Footer') {
        return { ...props, Phones: [{ Number: contactOverride.phone }] };
    }
    if (componentName === 'FloatingAction') {
        return { ...props, PhoneNumber: contactOverride.phone };
    }

    return props;
}

module.exports = {
    applyPageContactOverride,
    getEffectivePagePhone,
    getPageContactOverride,
};
